<div id="globalGlobalContainer">
    <div id="GreekParallax"> </div>
    <div id="globalContainer">
        <div id="header">
            <nav>
                <a routerLink="/dashboard">Dashboard</a>
                <a routerLink="/articles">Myth Classed</a>
                <a routerLink="/familyTree">Family Tree</a>
                <a routerLink="/galery">Gallery</a>
            </nav>
        </div>
        <div id="animation">
            <div id="container">    
                <h2>Myth Gallery</h2>
                <div class="articles-menu">
                    <a *ngFor="let article of articles" routerLink="/detail/{{article.id}}">
                        <img id="imageGalery" src="{{article.imageUrl}}"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <app-messages></app-messages>
    <div id="GreekParallax"> </div>
</div>
